import React, { useState, useEffect } from "react";
import {
  UncontrolledDropdown,
  CardBody,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption,
  CardHeader,
  Card,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
} from "reactstrap";
import { api } from "../../../../api";
import Cookies from "js-cookie";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import * as XLSX from "xlsx";

const Materials2 = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [dataToShow, setDataToShow] = useState([]);
  const [materialShow, setMaterialShow] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteProjectName, setDeleteProjectName] = useState("");

  const [entriesToShow, setEntriesToShow] = useState(5);
  const [projectDropdownOpen1, setProjectDropdownOpen1] = useState(false);
  const [projectDropdownOpen2, setProjectDropdownOpen2] = useState(false);

  const [modalAdd, setModalAdd] = useState(false);
  const toggleModalAdd = () => setModalAdd(!modalAdd);

  const [modalImport, setModalImport] = useState(false);
  const toggleModalImport = () => setModalImport(!modalImport);

  const [requestOption, setRequestOption] = useState("");
  const emp_id = Cookies.get("token") || Cookies.get("emp_id");
  console.log("Current emp_id from cookies:", emp_id);
  const [reqmaterial, setReqmaterial] = useState({
    emp_id: emp_id || "",
    p_id: "",
    mat_name: "",
    mat_quantity: "",
    mat_priority: "",
    mat_price: "",
    files: [],
    g_m_id: "",
  });
  const [profileImages, setProfileImages] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  
  // Form validation states
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  // Filter states
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [materialNameFilter, setMaterialNameFilter] = useState("");
  const [materialFilterDropdownOpen, setMaterialFilterDropdownOpen] = useState(false);
  const [dateRangeModalOpen, setDateRangeModalOpen] = useState(false);
  const [materialSearchQuery, setMaterialSearchQuery] = useState("");

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === profileImages.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? profileImages.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = profileImages.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <img
          src={item.src}
          alt={item.altText}
          style={{ width: "100%", maxHeight: "300px", objectFit: "contain" }}
        />
      </CarouselItem>
    );
  });

  const validateForm = () => {
    const newErrors = {};
    
    if (!reqmaterial.p_id || reqmaterial.p_id.trim() === '') {
      newErrors.p_id = 'Project name is required';
    }
    
    if (!reqmaterial.g_m_id || reqmaterial.g_m_id.trim() === '') {
      newErrors.g_m_id = 'General Manager is required';
    }
    
    if (!reqmaterial.mat_name || reqmaterial.mat_name.trim() === '') {
      newErrors.mat_name = 'Material name is required';
    }
    
    if (!reqmaterial.mat_quantity || reqmaterial.mat_quantity.trim() === '') {
      newErrors.mat_quantity = 'Material quantity is required';
    }
    
    if (!reqmaterial.mat_priority || reqmaterial.mat_priority.trim() === '') {
      newErrors.mat_priority = 'Material priority is required';
    }
    
    if (!reqmaterial.mat_price || reqmaterial.mat_price.trim() === '') {
      newErrors.mat_price = 'Material price is required';
    }
    
    // Validate that price is a positive number
    if (reqmaterial.mat_price && (isNaN(reqmaterial.mat_price) || parseFloat(reqmaterial.mat_price) <= 0)) {
      newErrors.mat_price = 'Material price must be a positive number';
    }
    
    // Validate that quantity is a positive number
    if (reqmaterial.mat_quantity && (isNaN(reqmaterial.mat_quantity) || parseFloat(reqmaterial.mat_quantity) <= 0)) {
      newErrors.mat_quantity = 'Material quantity must be a positive number';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setReqmaterial((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleBlur = (fieldName) => {
    setTouched(prev => ({
      ...prev,
      [fieldName]: true
    }));
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setReqmaterial((prevState) => ({
      ...prevState,
      files: files,
    }));
    const newImages = files.map((file) => ({
      src: URL.createObjectURL(file),
      altText: file.name,
    }));
    setProfileImages(newImages); // Replace existing images
    setActiveIndex(0); // Reset carousel index
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form before submission
    if (!validateForm()) {
      // Mark all fields as touched to show errors
      setTouched({
        p_id: true,
        g_m_id: true,
        mat_name: true,
        mat_quantity: true,
        mat_priority: true,
        mat_price: true
      });
      return;
    }

    // Set loading state
    setIsSubmitting(true);

    const formDataToSend = new FormData();
    formDataToSend.append("emp_id", reqmaterial.emp_id);
    formDataToSend.append("p_id", reqmaterial.p_id);
    formDataToSend.append("mat_name", reqmaterial.mat_name);
    formDataToSend.append("mat_quantity", reqmaterial.mat_quantity);
    formDataToSend.append("mat_priority", reqmaterial.mat_priority);
    formDataToSend.append("mat_price", reqmaterial.mat_price);

    if (reqmaterial.files && reqmaterial.files.length > 0) {
      for (let i = 0; i < reqmaterial.files.length; i++) {
        formDataToSend.append("files", reqmaterial.files[i]);
      }
    }
    formDataToSend.append("g_m_id", reqmaterial.g_m_id);
    const company_id = Cookies.get('company_id');
    formDataToSend.append("company_id", company_id);

    try {
      const response = await api.post(`materialrequest.php`, formDataToSend);
      console.log("Data sent successfully:", response.data);
      setSuccessMessage("Material request submitted successfully!");
      setShowSuccessAlert(true);
      toggleModalAdd(); // Close the modal after successful submission
      setReqmaterial({
        // Reset the form
        emp_id: emp_id || "",
        p_id: "",
        mat_name: "",
        mat_quantity: "",
        mat_priority: "",
        mat_price: "",
        files: [],
        g_m_id: "",
      });
      setProfileImages([]); // Clear uploaded images
      
      // Clear validation errors
      setErrors({});
      setTouched({});
    } catch (error) {
      console.error("Error submitting data:", error);
      setSuccessMessage(error.response?.data?.message || "Failed to submit material request. Please try again.");
      setShowSuccessAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRequestOptionChange = (e) => {
    setRequestOption(e.target.value);
    if (e.target.value === "single") {
      toggleModalAdd();
    } else if (e.target.value === "multiple") {
      toggleModalImport();
    }
  };

  const shopName = [
    { value: "Low", label: "Low" },
    { value: "High", label: "High" },
  ];
  const projects = ["Project 1", "Project 2", "Project 3", "Project 4"];

  const handleDeleteConfirmation = (confirmed, deleteInfo) => {
    if (confirmed && deleteInfo) {
      if (deleteInfo.type === "mat_id") {
        // Excel uploaded data: DELETE request with mat_id
        const fetchData = async () => {
          try {
            const company_id = Cookies.get('company_id');
            const response = await api.delete(`deleteMaterial.php?company_id=${company_id}`, {
              data: { mat_id: deleteInfo.value },
            });
            console.log(response.data);
            // Optionally refresh data
            window.location.reload();
          } catch (error) {
            console.error("Error deleting Excel uploaded data:", error);
          }
        };
        fetchData();
      } else if (deleteInfo.type === "m_id") {
        // Single data: GET request with m_id
        const fetchData = async () => {
          try {
            const company_id = Cookies.get('company_id');
            const response = await api.get(
              `deleteMaterial.php?id=${deleteInfo.value}&company_id=${company_id}`
            );
            console.log(response.data);
            // Optionally refresh data
            window.location.reload();
          } catch (error) {
            console.error("Error deleting single data:", error);
          }
        };
        fetchData();
      }
    }
    setShowDeleteConfirmation(false);
  };

  // emp_id is already declared at the top

  const [modalOpen, setModalOpen] = useState(false);
  const toggleModalView = () => {
    setModalOpen(!modalOpen);
  };
  const [modalEmployee, setModalEmployee] = useState(null);
  const [multipleMaterialsData, setMultipleMaterialsData] = useState(null);
  const [isMultipleMaterials, setIsMultipleMaterials] = useState(false);
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const [modalEntriesPerPage, setModalEntriesPerPage] = useState(5);
  const [modalEntriesDropdownOpen, setModalEntriesDropdownOpen] = useState(false);

  const [project, setProject] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(
          `viewProjectDetails.php?s_m_id=${emp_id}&company_id=${company_id}`
        );
        setProject(Array.isArray(response.data) ? response.data : []);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const [projectmanager, setprojectmanager] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        if (!company_id) {
          console.warn("No company_id found in cookies");
          setprojectmanager([]);
          return;
        }
        
        const response = await api.post(`employeesView.php?company_id=${company_id}`);
        // Filter to show only General Managers from the current company
        const generalManagers = response.data.filter(emp => 
          emp.role === 'General Manager' && emp.company_id === company_id
        );
        setprojectmanager(generalManagers);
        console.log("General Managers for company:", generalManagers);
      } catch (error) {
        console.error("Error fetching data:", error);
        setprojectmanager([]);
      }
    };
    fetchData();
  }, [Cookies.get('company_id')]);

  const [allmaterial, setallmaterial] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        console.log("Fetching data for emp_id:", emp_id, "company_id:", company_id);
        
        // Fetch only Site Engineer's data
        const response = await api.get(
          `materialrequest.php?emp_id=${emp_id}&company_id=${company_id}`
        );
        console.log("Material request response:", response.data);
        
        if (Array.isArray(response.data)) {
          // Check if data contains the correct emp_id
          const filteredData = response.data.filter(item => {
            console.log("Checking item emp_id:", item.emp_id, "against current emp_id:", emp_id);
            return item.emp_id == emp_id; // Use == for type coercion
          });
          console.log("Filtered data for current emp_id:", filteredData);
          
          // Sort data in descending order by Date_Time (most recent first)
          const sortedData = filteredData.sort((a, b) => {
            const dateA = new Date(a.Date_Time);
            const dateB = new Date(b.Date_Time);
            return dateB - dateA; // Descending order (newest first)
          });
          setDataToShow(sortedData.slice(0, entriesToShow));
          setMaterialShow(sortedData);
        } else {
          setDataToShow([]);
          setMaterialShow([]);
        }
        console.log("Site Engineer's material requests:", response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setDataToShow([]);
        setMaterialShow([]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        console.log("Fetching uploaded materials for emp_id:", emp_id, "company_id:", company_id);
        
        // Fetch only Site Engineer's uploaded materials
        const response = await api.get(`uploadMaterials.php?emp_id=${emp_id}&company_id=${company_id}`);
        console.log("Upload materials response:", response.data);
        
        if (Array.isArray(response.data)) {
          // Check if data contains the correct emp_id
          const filteredUploadedData = response.data.filter(item => {
            console.log("Checking uploaded item emp_id:", item.emp_id, "against current emp_id:", emp_id);
            return item.emp_id == emp_id; // Use == for type coercion
          });
          console.log("Filtered uploaded data for current emp_id:", filteredUploadedData);
          
          // Sort uploaded materials in descending order by Date_Time
          const sortedUploadedData = filteredUploadedData.sort((a, b) => {
            const dateA = new Date(a.Date_Time);
            const dateB = new Date(b.Date_Time);
            return dateB - dateA; // Descending order (newest first)
          });
          
          setDataToShow((prev) => {
            const combined = [...prev, ...sortedUploadedData];
            // Re-sort the combined data to maintain descending order
            return combined.sort((a, b) => {
              const dateA = new Date(a.Date_Time);
              const dateB = new Date(b.Date_Time);
              return dateB - dateA;
            });
          });
          
          setMaterialShow((prev) => {
            const combined = [...prev, ...sortedUploadedData];
            // Re-sort the combined data to maintain descending order
            return combined.sort((a, b) => {
              const dateA = new Date(a.Date_Time);
              const dateB = new Date(b.Date_Time);
              return dateB - dateA;
            });
          });
        } else {
          // If not array, do not add
        }
        console.log("Site Engineer's uploaded materials:", response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleProjectSelection = async (p_id) => {
    try {
      const company_id = Cookies.get('company_id');
      if (p_id) {
        const response = await api.get(
          `materialrequest.php?p_id=${p_id}&emp_id=${emp_id}&company_id=${company_id}`
        );
        let projectData = [];
        if (Array.isArray(response.data)) {
          // Sort project materials in descending order
          projectData = response.data.sort((a, b) => {
            const dateA = new Date(a.Date_Time);
            const dateB = new Date(b.Date_Time);
            return dateB - dateA;
          });
        }
        
        const response2 = await api.get(
          `uploadMaterials.php?p_id=${p_id}&emp_id=${emp_id}&company_id=${company_id}`
        );
        let uploadedData = [];
        if (Array.isArray(response2.data)) {
          // Sort uploaded materials in descending order
          uploadedData = response2.data.sort((a, b) => {
            const dateA = new Date(a.Date_Time);
            const dateB = new Date(b.Date_Time);
            return dateB - dateA;
          });
        }
        
        // Combine and sort all data
        const combinedData = [...projectData, ...uploadedData].sort((a, b) => {
          const dateA = new Date(a.Date_Time);
          const dateB = new Date(b.Date_Time);
          return dateB - dateA;
        });
        
        setDataToShow(combinedData);
      } else {
        setDataToShow(materialShow);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setDataToShow([]);
    }
  };

  const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [showWasteFields, setShowWasteFields] = useState(false);
  const [showReplaceFields, setShowReplaceFields] = useState(false);

  const totalPages = Math.ceil(materialShow.length / entriesToShow);
  // useEffect(() => {
  //   if (Array.isArray(filteredData)) {
  //     setDataToShow(
  //       filteredData.slice(
  //         (currentPage - 1) * entriesToShow,
  //         currentPage * entriesToShow
  //       )
  //     );
  //   }
  // }, [entriesToShow, currentPage, filteredData, totalPages]);

  const toggleProjectDropdown = () => {
    setProjectDropdownOpen(!projectDropdownOpen);
  };

  const toggleProjectDropdown1 = () => {
    setProjectDropdownOpen1(!projectDropdownOpen1);
  };

  const toggleProjectDropdown2 = () => {
    setProjectDropdownOpen2(!projectDropdownOpen2);
  };

  const toggleDateRangeModal = () => {
    setDateRangeModalOpen(!dateRangeModalOpen);
  };

  const toggleMaterialFilterDropdown = () => {
    setMaterialFilterDropdownOpen(!materialFilterDropdownOpen);
  };

  const handleEntriesChange = (value) => {
    setEntriesToShow(value === "All" ? materialShow.length : Number(value));
    setCurrentPage(1);
  };

  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const getSerialNumber = (index) => {
    return (currentPage - 1) * entriesToShow + index + 1;
  };

  const changeCPage = (n) => {
    setCurrentPage(n);
  };

  // Get unique material names for filter dropdown with search
  const getUniqueMaterialNames = () => {
    let names = [...new Set(materialShow.map(item => item.mat_name || item.mat_fileName).filter(Boolean))];
    
    // Apply search filter if there's a search query
    if (materialSearchQuery.trim()) {
      names = names.filter(name => 
        name.toLowerCase().includes(materialSearchQuery.toLowerCase())
      );
    }
    
    return names.sort();
  };

  // Apply filters
  const applyFilters = (data) => {
    let filtered = [...data];

    // Apply date range filter
    if (startDate || endDate) {
      filtered = filtered.filter(item => {
        if (item.Date_Time) {
          // Parse the item date and normalize to YYYY-MM-DD format
          const itemDate = new Date(item.Date_Time);
          const itemDateStr = itemDate.toISOString().split('T')[0]; // Get YYYY-MM-DD format
          
          if (startDate && endDate) {
            // Both start and end date selected
            // Normalize both dates to YYYY-MM-DD format for accurate comparison
            const startDateStr = startDate; // Already in YYYY-MM-DD format
            const endDateStr = endDate; // Already in YYYY-MM-DD format
            
            // For same day selection (start === end), we want to include the entire day
            if (startDateStr === endDateStr) {
              return itemDateStr === startDateStr;
            } else {
              return itemDateStr >= startDateStr && itemDateStr <= endDateStr;
            }
          } else if (startDate) {
            // Only start date selected - from start date to current date
            const startDateStr = startDate;
            return itemDateStr >= startDateStr;
          } else if (endDate) {
            // Only end date selected - from beginning to end date
            const endDateStr = endDate;
            return itemDateStr <= endDateStr;
          }
        }
        return false;
      });
    }

    // Apply material name filter
    if (materialNameFilter) {
      filtered = filtered.filter(item => {
        const materialName = item.mat_name || item.mat_fileName || '';
        return materialName.toLowerCase().includes(materialNameFilter.toLowerCase());
      });
    }

    return filtered;
  };

  // Clear all filters
  const clearFilters = () => {
    setStartDate("");
    setEndDate("");
    setMaterialNameFilter("");
    setMaterialSearchQuery("");
  };

  // Apply date range filter
  const applyDateRange = () => {
    setDateRangeModalOpen(false);
  };

  // Get date range display text
  const getDateRangeText = () => {
    if (startDate && endDate) {
      return `Date: ${new Date(startDate).toLocaleDateString()} - ${new Date(endDate).toLocaleDateString()}`;
    } else if (startDate) {
      return `From: ${new Date(startDate).toLocaleDateString()}`;
    } else if (endDate) {
      return `Until: ${new Date(endDate).toLocaleDateString()}`;
    }
    return "Filter by Date Range";
  };

  // Download function for multiple materials
  const handleDownloadMultipleMaterials = () => {
    if (!multipleMaterialsData) return;
    
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = `materials_${new Date().toISOString().split('T')[0]}`;

    // Prepare data for Excel
    const excelData = multipleMaterialsData.materials.map((material, index) => ({
      'Sr. No': index + 1,
      'Material Name': material.mat_name || 'N/A',
      'Quantity': material.mat_quantity || 'N/A',
      'Budget': material.mat_money || 'N/A',
      'Priority': multipleMaterialsData.metadata.Priority || 'N/A',
      'Date': multipleMaterialsData.metadata.Date_Time || 'N/A',
      'Status': multipleMaterialsData.metadata.mat_status || 'N/A'
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

    // Apply styling to headers
    const headerCellStyle = {
      font: { bold: true },
      fill: { bgColor: { indexed: 64 } },
    };
    Object.keys(ws)
      .filter((key) => key.startsWith("A1"))
      .forEach((key) => (ws[key].s = headerCellStyle));

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelDataBlob = new Blob([excelBuffer], { type: fileType });
    const excelUrl = URL.createObjectURL(excelDataBlob);
    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = fileName + fileExtension;
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(excelUrl);
    }, 100);
  };

  // Modal pagination functions
  const getModalPaginatedMaterials = () => {
    if (!multipleMaterialsData) return [];
    const startIndex = (modalCurrentPage - 1) * modalEntriesPerPage;
    const endIndex = startIndex + modalEntriesPerPage;
    return multipleMaterialsData.materials.slice(startIndex, endIndex);
  };

  const getModalTotalPages = () => {
    if (!multipleMaterialsData) return 0;
    return Math.ceil(multipleMaterialsData.materials.length / modalEntriesPerPage);
  };

  const handleModalPageChange = (page) => {
    setModalCurrentPage(page);
  };

  const handleModalEntriesChange = (value) => {
    setModalEntriesPerPage(value === "All" ? multipleMaterialsData.materials.length : Number(value));
    setModalCurrentPage(1);
  };

  const getModalSerialNumber = (index) => {
    return (modalCurrentPage - 1) * modalEntriesPerPage + index + 1;
  };

  useEffect(() => {
    if (Array.isArray(materialShow)) {
      let filteredData = [...materialShow];

      // Apply search filter
      if (searchQuery.trim() !== "") {
        const searchQueryLower = searchQuery.toLowerCase();
        filteredData = filteredData.filter((item) => {
          const matchName =
            item?.mat_name?.toLowerCase()?.includes(searchQueryLower) || false;
          const matchStatus =
            item?.mat_status?.toLowerCase()?.includes(searchQueryLower) ||
            false;
          const matchFileName =
            item?.mat_fileName?.toLowerCase()?.includes(searchQueryLower) ||
            false;

          return matchName || matchStatus || matchFileName;
        });
      }

      // Apply date and material name filters
      filteredData = applyFilters(filteredData);
      
      // Sort filtered data in descending order by Date_Time
      const sortedFilteredData = filteredData.sort((a, b) => {
        const dateA = new Date(a.Date_Time);
        const dateB = new Date(b.Date_Time);
        return dateB - dateA; // Descending order (newest first)
      });
      
      setDataToShow(sortedFilteredData.slice(0, entriesToShow));
    } else {
      setDataToShow([]);
    }
  }, [searchQuery, entriesToShow, currentPage, materialShow, startDate, endDate, materialNameFilter]);

  const style = () => {
    const nextIcon = document.querySelector(".carousel-control-next-icon");
    if (nextIcon) {
      nextIcon.style.backgroundColor = "black";
    }

    const prevIcon = document.querySelector(".carousel-control-prev-icon");
    if (prevIcon) {
      prevIcon.style.backgroundColor = "black";
    }
  };
  style();

  const images = [
    "../../../images/65e867cb84c92_platter-2009590_960_720 copy.jpg",
    "../../../images/65e867cb84c92_platter-2009590_960_720.jpg",
  ];
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const [activeIndex1, setActiveIndex1] = useState(0);
  const imagesString = modalEmployee?.files;
  const imagesArray = imagesString ? imagesString.split(",") : [];

  const next1 = () => {
    if (animating || imagesArray.length === 0) return;
    const nextIndex =
      activeIndex1 === imagesArray.length - 1 ? 0 : activeIndex1 + 1;
    setActiveIndex1(nextIndex);
  };

  const previous1 = () => {
    if (animating || imagesArray.length === 0) return;
    const nextIndex =
      activeIndex1 === 0 ? imagesArray.length - 1 : activeIndex1 - 1;
    setActiveIndex1(nextIndex);
  };

  const goToIndex1 = (newIndex) => {
    if (animating || imagesArray.length === 0) return;
    setActiveIndex1(newIndex);
  };

  const slides1 = imagesArray.map((image, index) => (
        <CarouselItem
          onExiting={() => setAnimating(true)}
          onExited={() => setAnimating(false)}
          key={index}
        >
      <div className="profile-image-container" style={{ width: "376px", height: "256px", border: "2px solid black", borderRadius: "9%", overflow: "hidden", boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)", margin: "0 auto" }}>
            <img
              alt={`Uploaded Image ${index + 1 + image}`}
          src={image ? `/images/${image}` : '/images/default-profile.png'}
          onError={e => { e.target.onerror = null; e.target.src = '/images/default-profile.png'; }}
          style={{ width: "100%", height: "100%" }}
            />
          </div>
          <CarouselCaption captionText="" captionHeader="" />
        </CarouselItem>
  )).filter((slide) => slide !== null);

  const [importedFileDetails, setImportedFileDetails] = useState(null);
  const [importedFile, setImportedFile] = useState(null);

  // New file upload handler for import modal
  const handleImportFileUpload = (e) => {
    const file = e.target.files[0];
    const allowedTypes = [
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "text/csv", // .csv
    ];

        if (file) {
          // Check file type
          if (!allowedTypes.includes(file.type)) {
            setSuccessMessage("Please upload only .csv, .xls, or .xlsx files");
            setShowSuccessAlert(true);
            e.target.value = ""; // Clear the file input
            setImportedFileDetails(null);
            return;
          }

      setImportedFile(file);
      setImportedFileDetails({
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
        uploadTime: new Date().toLocaleString(),
      });
    }
  };

  const handleImportSubmit = async (e) => {
    e.preventDefault();

    if (!importedFile) {
      setSuccessMessage("Please upload a file.");
      setShowSuccessAlert(true);
      return;
    }

    // Debug logging to check what values are being sent
    console.log("Debug - Values being sent:", {
      emp_id,
      g_m_id: reqmaterial.g_m_id,
      p_id: reqmaterial.p_id,
      mat_priority: reqmaterial.mat_priority,
      company_id: Cookies.get('company_id')
    });

    // Validation for required fields
    if (!emp_id) {
      setSuccessMessage("Employee ID is missing. Please log in again.");
      setShowSuccessAlert(true);
      return;
    }

    if (!reqmaterial.g_m_id) {
      setSuccessMessage("Please select a General Manager.");
      setShowSuccessAlert(true);
      return;
    }

    if (!reqmaterial.p_id) {
      setSuccessMessage("Please select a Project.");
      setShowSuccessAlert(true);
      return;
    }

    if (!reqmaterial.mat_priority) {
      setSuccessMessage("Please select a Priority.");
      setShowSuccessAlert(true);
      return;
    }

    const company_id = Cookies.get('company_id');
    if (!company_id) {
      setSuccessMessage("Company ID is missing. Please log in again.");
      setShowSuccessAlert(true);
      return;
    }

    // Set loading state
    setIsImporting(true);

    const formData = new FormData();
    formData.append("importFile", importedFile);
    formData.append("p_id", reqmaterial.p_id); // Assuming you store p_id in reqmaterial
    formData.append("g_m_id", reqmaterial.g_m_id); // Assuming you store g_m_id in reqmaterial
    formData.append("mat_priority", reqmaterial.mat_priority); // Assuming you store priority in reqmaterial
    formData.append("emp_id", emp_id); // Make sure you have access to emp_id
    formData.append("company_id", company_id);

    try {
      const response = await api.post(`uploadMaterials.php`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Import successful:", response.data);
      setSuccessMessage(response.data.message || "File imported successfully!");
      setShowSuccessAlert(true);
      toggleModalImport();
      // Reset form
      setImportedFile(null);
      setImportedFileDetails(null);
      setReqmaterial({
        emp_id: emp_id || "",
        p_id: "",
        mat_name: "",
        mat_quantity: "",
        mat_priority: "",
        mat_price: "",
        files: [],
        g_m_id: "",
      });
    } catch (error) {
      console.error("Error importing file:", error);
      setSuccessMessage(error.response?.data?.error || "Failed to import file. Please try again.");
      setShowSuccessAlert(true);
    } finally {
      setIsImporting(false);
    }
  };

  // New import submit handler
  // const handleImportSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!importedFileDetails) {
  //     alert("Please select a file to import");
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("file", e.target.importFile.files[0]);
  //   formData.append("p_id", reqmaterial.p_id);
  //   formData.append("g_m_id", reqmaterial.g_m_id);

  //   try {
  //     const response = await api.post("importMaterials.php", formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     // Update material show with imported data
  //     setMaterialShow(response.data);
  //     setImportedFileDetails(null);
  //     toggleModalImport(); // Close modal
  //   } catch (error) {
  //     console.error("Import failed", error);
  //     alert("Failed to import file");
  //   }
  // };

  // Modify your table rendering function
  const renderTableRows = () => {
    return materialShow.map((item, index) => (
      <tr key={index}>
        <td>{getSerialNumber(index)}</td>
        <td>
          {importedFileDetails
            ? `Imported: ${importedFileDetails.fileName}`
            : item.mat_name}
        </td>
        <td>{importedFileDetails ? "N/A" : item.mat_quantity}</td>
        <td>{importedFileDetails ? "N/A" : item.mat_price}</td>
        <td>
          {importedFileDetails
            ? importedFileDetails.uploadTime
            : item.Date_Time}
        </td>
        <td>{item.mat_status}</td>
        <td>{item.gm_report}</td>
      </tr>
    ));
  };

  const [selectedProjectName, setSelectedProjectName] = useState("Select Project");

  // Success alert for material request
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  
  // Loading states
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isImporting, setIsImporting] = useState(false);

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row className="align-items-center mb-5">
            <Col className="order-xl-1 mb-5 mb-xl-0 text-left">
              <h1>Materials Details</h1>
  </Col>
            <Col className="order-xl-2 mb-5 mb-xl-0 d-flex justify-content-end">
              <Dropdown
                isOpen={projectDropdownOpen}
                toggle={toggleProjectDropdown}
                className="mr-3"
              >
                <DropdownToggle caret>
                  Select Project
                </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => handleProjectSelection()}>All</DropdownItem>
        {Array.isArray(project) && project.length > 0 ? (
          project.map((project) => (
            <DropdownItem
              key={project.p_id}
              onClick={() => handleProjectSelection(project.p_id)}
            >
              {project.p_name}
            </DropdownItem>
          ))
        ) : (
                    <DropdownItem>No Project Yet?</DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  </Col>
            <Col className="order-xl-2 mb-5 mb-xl-0 d-flex">
              <Form className="navbar-search form-inline ml-5 d-none d-md-flex ml-lg-auto">
                <FormGroup className="mb-0 ml-6">
                  <InputGroup className="input-group-alternative">
        <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fas fa-search" style={{color: 'black'}}/>
                      </InputGroupText>
                    </InputGroupAddon>
            <Input
          placeholder="Search Materials"
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </InputGroup>
    </FormGroup>
  </Form>
</Col>
</Row>
          <Row className="">
            <Col
              className="mb-5 mb-xl-0"
              xl="12"
              style={{ marginTop: "-20px" }}
            >
              <Card className="" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px'}}>
                <CardBody>
                  <CardHeader className="border-0">
                    <Row className="align-items-left">
                      <div className="col">
                        <div className="col text-right">
                          <div className="d-flex flex-column flex-sm-row justify-end items-sm-center md:ml-4">
                            {/* Date Range Filter */}
                            <div className="mr-2 mb-2">
                              <Button
                                size="sm"
                                color="info"
                                onClick={toggleDateRangeModal}
                                style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                                className="px-3"
                              >
                                <i className="fas fa-calendar-alt mr-1"></i>
                                {getDateRangeText()}
                              </Button>
                            </div>

                            {/* Material Name Filter */}
                            <div className="mr-2 mb-2">
                              <Dropdown
                                isOpen={materialFilterDropdownOpen}
                                toggle={toggleMaterialFilterDropdown}
                              >
                                <DropdownToggle caret className="px-3">
                                  {materialNameFilter ? `Material: ${materialNameFilter}` : "Filter by Material"}
                                </DropdownToggle>
                                <DropdownMenu style={{ width: '300px', padding: '8px', maxHeight: '250px', overflowY: 'auto' }}>
                                  {/* Search Bar Inside Dropdown */}
                                  <div className="mb-2">
                                    <Input
                                      type="text"
                                      placeholder="Search materials..."
                                      value={materialSearchQuery || ''}
                                      onChange={(e) => setMaterialSearchQuery(e.target.value)}
                                      style={{ fontSize: '13px', height: '32px' }}
                                    />
                                  </div>
                                  <DropdownItem 
                                    onClick={() => {
                                      setMaterialNameFilter("");
                                      setMaterialSearchQuery("");
                                    }}
                                    style={{ padding: '6px 12px', fontSize: '13px' }}
                                  >
                                    All Materials
                                  </DropdownItem>
                                  {getUniqueMaterialNames().length > 0 ? (
                                    getUniqueMaterialNames().map((name, index) => (
                                      <DropdownItem
                                        key={index}
                                        onClick={() => {
                                          setMaterialNameFilter(name);
                                          setMaterialSearchQuery("");
                                        }}
                                        style={{ 
                                          padding: '6px 12px', 
                                          fontSize: '13px',
                                          backgroundColor: materialNameFilter === name ? '#f8f9fa' : 'transparent',
                                          fontWeight: materialNameFilter === name ? 'bold' : 'normal'
                                        }}
                                      >
                                        {name}
                                      </DropdownItem>
                                    ))
                                  ) : (
                                    <DropdownItem disabled style={{ padding: '6px 12px', fontSize: '13px' }}>
                                      <small className="text-muted">No materials found</small>
                                    </DropdownItem>
                                  )}
                                </DropdownMenu>
                              </Dropdown>
                            </div>

                            {/* Clear Filters Button */}
                            {(startDate || endDate || materialNameFilter) && (
                              <div className="mr-2 mb-2">
                                <Button
                                  size="sm"
                                  color="secondary"
                                  onClick={clearFilters}
                                  className="px-3"
                                >
                                  Clear Filters
                                </Button>
                              </div>
                            )}

                            <div className="mb-2 sm:mb-0">
                              <Dropdown
                                isOpen={projectDropdownOpen1}
                                toggle={toggleProjectDropdown1}
                              >
                                <DropdownToggle caret >
                                  Show Entries:{" "}
                                  {entriesToShow === filteredData.length
                                    ? "All"
                                    : entriesToShow}
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    onClick={() => handleEntriesChange(5)}
                                  >
                                    5
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => handleEntriesChange(10)}
                                  >
                                    10
                                  </DropdownItem>
                                  <DropdownItem
                                    onClick={() => handleEntriesChange("All")}
                                  >
                                    All
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                            <Dropdown
                              isOpen={projectDropdownOpen2}
                              toggle={toggleProjectDropdown2}
                            >
                              <DropdownToggle caret>
                                Request Materials
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem
                                  onClick={() =>
                                    handleRequestOptionChange({
                                      target: { value: "" },
                                    })
                                  }
                                >
                                  Request Materials
                                </DropdownItem>
                                <DropdownItem
                                  onClick={() =>
                                    handleRequestOptionChange({
                                      target: { value: "single" },
                                    })
                                  }
                                >
                                  Add Single Material
                                </DropdownItem>
                                <DropdownItem
                                  onClick={() =>
                                    handleRequestOptionChange({
                                      target: { value: "multiple" },
                                    })
                                  }
                                >
                                  Import Multiple Datas
                                </DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    </Row>
                  </CardHeader>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">SL.No</th>
                        <th scope="col">Project Name</th>
                        <th scope="col">Material Name</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Price</th>
                        <th scope="col">Date/time</th>
                        <th scope="col">Status</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(dataToShow) && dataToShow.length > 0 ? (
                        dataToShow.map((item, index) => (
                          <tr key={index}>
                            <th scope="row">{getSerialNumber(index)}</th>
                            <td>{item.p_name || "N/A"}</td>
                            <td>{item.mat_name || item.mat_fileName}</td>
                            <td>{item.mat_quantity || "N/A"}</td>
                            <td>{item.mat_money || "N/A"}</td>
                            <td>{item.Date_Time}</td>
                            <td>{item.store_status || item.mat_status}</td>
                            <td>
                              <button
                                onClick={() => {
                                  if (item.mat_data) {
                                    const matData = JSON.parse(item.mat_data);

                                    // Check if there are multiple materials (more than 1)
                                    if (matData.length > 1) {
                                      // Show multiple materials in table format
                                      setMultipleMaterialsData({
                                        materials: matData,
                                        metadata: {
                                          Priority: item.Priority,
                                          Date_Time: item.Date_Time,
                                          mat_status: item.mat_status,
                                          gm_report: item.gm_report,
                                          store_status: item.store_status,
                                          store_report: item.store_report,
                                          files: item.files
                                        }
                                      });
                                      setIsMultipleMaterials(true);
                                      // Reset pagination for multiple materials
                                      setModalCurrentPage(1);
                                      setModalEntriesPerPage(5);
                                    } else {
                                      // Single material - use existing format
                                    const merged = {
                                        mat_name: matData[0].mat_name,
                                        mat_money: matData[0].mat_money,
                                        mat_quantity: matData[0].mat_quantity,
                                      Priority: item.Priority,
                                      Date_Time: item.Date_Time,
                                      mat_status: item.mat_status,
                                      gm_report: item.gm_report,
                                        store_status: item.store_status,
                                        store_report: item.store_report,
                                        files: item.files
                                    };
                                    setModalEmployee(merged);
                                      setIsMultipleMaterials(false);
                                    }
                                  } else {
                                    // Single material from regular upload
                                    setModalEmployee(item);
                                    setIsMultipleMaterials(false);
                                  }
                                  // Reset pagination when opening modal
                                  setModalCurrentPage(1);
                                  setModalEntriesPerPage(5);
                                  toggleModalView();
                                }}
                                className="btn btn-deeppink"
                              >
                                <Tippy content="View Details">
                                  <i className="fa-solid fa-eye"></i>
                                </Tippy>
                              </button>
                              {/* <button
                                onClick={() => {
                                  if (item.mat_id) {
                                    setDeleteProjectName({
                                      type: "mat_id",
                                      value: item.mat_id,
                                    });
                                  } else if (item.m_id) {
                                    setDeleteProjectName({
                                      type: "m_id",
                                      value: item.m_id,
                                    });
                                  }
                                  setShowDeleteConfirmation(true);
                                }}
                                className="btn btn-deeppink"
                              >
                                <Tippy content="Delete Material">
                                  <i class="fa-solid fa-trash text-danger"></i>
                                </Tippy>
                              </button> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td style={{ textAlign: "center" }} colSpan="8">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>

                  <nav className="mt-3">
                    <ul className="pagination justify-content-center">
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link text-primary"
                          onClick={prePage}
                          disabled={currentPage === 1}
                        >
                          Prev
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          href="#"
                          className="page-link text-primary"
                          onClick={nextPage}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={modalAdd} toggle={toggleModalAdd}>
        <ModalHeader toggle={toggleModalAdd}>Add Materials</ModalHeader>
        <Form onSubmit={handleFormSubmit} encType="multipart/form-data">
          <Row className="px-3">
            <Col md={12}>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-status">
                  Project Name
                </label>
                <Input
                  className={`form-control-alternative ${errors.p_id && touched.p_id ? 'is-invalid' : ''}`}
                  id="input-status"
                  type="select"
                  name="p_id"
                  onChange={handleInputChange}
                  onBlur={() => handleBlur('p_id')}
                  value={reqmaterial.p_id}
                >
                  <option value="">Select Project Name</option>
                  {project && project.length > 0 ? (
                    project.map((option) => (
                      <option key={option.p_id} value={option.p_id}>
                        {option.p_name}
                      </option>
                    ))
                  ) : (
                    <option value="">No projects available</option>
                  )}
                </Input>
                {errors.p_id && touched.p_id && (
                  <div className="invalid-feedback d-block">
                    {errors.p_id}
                  </div>
                )}
              </FormGroup>
            </Col>

            <Col md={12}>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-status">
                  General Manager
                </label>
                <Input
                  className={`form-control-alternative ${errors.g_m_id && touched.g_m_id ? 'is-invalid' : ''}`}
                  id="input-status"
                  type="select"
                  name="g_m_id"
                  onChange={handleInputChange}
                  onBlur={() => handleBlur('g_m_id')}
                  value={reqmaterial.g_m_id}
                >
                  <option value="">Select General Manager</option>
                  {Array.isArray(projectmanager) &&
                  projectmanager.length > 0 ? (
                    projectmanager.map((option) => (
                      <option key={option.emp_id} value={option.emp_id}>
                        {option.emp_name + " [" + option.role + "]"}
                      </option>
                    ))
                  ) : (
                    <option value="">No General Managers available</option>
                  )}
                </Input>
                {errors.g_m_id && touched.g_m_id && (
                  <div className="invalid-feedback d-block">
                    {errors.g_m_id}
                  </div>
                )}
              </FormGroup>
            </Col>

            <Col md={12}>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-name">
                  Material Name
                </label>
                <Input
                  className={`form-control-alternative ${errors.mat_name && touched.mat_name ? 'is-invalid' : ''}`}
                  id="input-material"
                  type="text"
                  name="mat_name"
                  onChange={handleInputChange}
                  onBlur={() => handleBlur('mat_name')}
                  placeholder="Material Name"
                  value={reqmaterial.mat_name}
                />
                {errors.mat_name && touched.mat_name && (
                  <div className="invalid-feedback d-block">
                    {errors.mat_name}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-name">
                  Material Quantity
                </label>
                <Input
                  className={`form-control-alternative ${errors.mat_quantity && touched.mat_quantity ? 'is-invalid' : ''}`}
                  id="input-material"
                  type="text"
                  name="mat_quantity"
                  onChange={handleInputChange}
                  onBlur={() => handleBlur('mat_quantity')}
                  placeholder="Material Quantity"
                  value={reqmaterial.mat_quantity}
                />
                {errors.mat_quantity && touched.mat_quantity && (
                  <div className="invalid-feedback d-block">
                    {errors.mat_quantity}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-status">
                  Materials Priority{" "}
                </label>
                <Input
                  className={`form-control-alternative ${errors.mat_priority && touched.mat_priority ? 'is-invalid' : ''}`}
                  id="input-status"
                  type="select"
                  name="mat_priority"
                  onChange={handleInputChange}
                  onBlur={() => handleBlur('mat_priority')}
                  value={reqmaterial.mat_priority}
                >
                  <option value="">Select Priority</option>
                  {shopName.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Input>
                {errors.mat_priority && touched.mat_priority && (
                  <div className="invalid-feedback d-block">
                    {errors.mat_priority}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup>
                <label className="form-control-label" htmlFor="input-budget">
                  Material Price
                </label>
                <Input
                  className={`form-control-alternative ${errors.mat_price && touched.mat_price ? 'is-invalid' : ''}`}
                  id="input-budget"
                  type="number"
                  name="mat_price"
                  onChange={handleInputChange}
                  onBlur={() => handleBlur('mat_price')}
                  placeholder="Material Price"
                  value={reqmaterial.mat_price}
                />
                {errors.mat_price && touched.mat_price && (
                  <div className="invalid-feedback d-block">
                    {errors.mat_price}
                  </div>
                )}
              </FormGroup>
            </Col>

            <Col md={12}>
              <label className="form-control-label" htmlFor="input-budget">
                Upload Images
              </label>

              <Carousel
                activeIndex={activeIndex}
                next={next}
                previous={previous}
              >
                <CarouselIndicators
                  items={profileImages.map((_, index) => ({ key: index }))}
                  activeIndex={activeIndex}
                  onClickHandler={goToIndex}
                />
                {slides}
                {profileImages.length > 0 && (
                  <CarouselControl
                    direction="prev"
                    directionText="Previous"
                    onClickHandler={previous}
                    style={{ backgroundColor: "black" }}
                  />
                )}
                {profileImages.length > 0 && (
                  <CarouselControl
                    direction="next"
                    directionText="Next"
                    onClickHandler={next}
                  />
                )}
              </Carousel>
            </Col>
            <Col lg="12" className="text-left m-2">
              <Button
                style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white' }}
                onClick={() =>
                  document.getElementById("input-profile-image").click()
                }
              >
                Upload
              </Button>

              <FormGroup style={{ display: "none" }}>
                <Input
                  type="file"
                  id="input-profile-image"
                  accept="image/*"
                  onChange={handleFileUpload}
                  multiple
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col lg="12" className="text-center mb-2">
              <Button 
                style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} 
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Submitting...
                  </>
                ) : (
                  'Submit'
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal isOpen={modalImport} toggle={toggleModalImport}>
        <ModalHeader toggle={toggleModalImport}>
          Import Multiple Datas
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleImportSubmit}>
            <FormGroup>
              <label className="form-control-label" htmlFor="input-project">
                Project Name
              </label>
              <Input
                className="form-control-alternative"
                id="input-project"
                type="select"
                name="p_id"
                onChange={handleInputChange}
                value={reqmaterial.p_id}
              >
                <option value="">Select Project Name</option>
                {project && project.length > 0 ? (
                  project.map((option) => (
                    <option key={option.p_id} value={option.p_id}>
                      {option.p_name}
                    </option>
                  ))
                ) : (
                  <option value="">No projects available</option>
                )}
              </Input>
            </FormGroup>

            <FormGroup>
              <label className="form-control-label" htmlFor="input-manager">
                General Manager
              </label>
              <Input
                className="form-control-alternative"
                id="input-manager"
                type="select"
                name="g_m_id"
                onChange={handleInputChange}
                value={reqmaterial.g_m_id}
              >
                <option value="">Select General Manager</option>
                {Array.isArray(projectmanager) && projectmanager.length > 0 ? (
                  projectmanager.map((option) => (
                    <option key={option.emp_id} value={option.emp_id}>
                      {option.emp_name + " [" + option.role + "]"}
                    </option>
                  ))
                ) : (
                  <option value="">No General Managers available</option>
                )}
              </Input>
            </FormGroup>

            <FormGroup>
              <label className="form-control-label" htmlFor="input-status">
                Materials Priority{" "}
              </label>
              <Input
                className="form-control-alternative"
                id="input-status"
                type="select"
                name="mat_priority"
                onChange={handleInputChange}
                value={reqmaterial.mat_priority}
              >
                <option value="">Select Priority</option>
                {shopName.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="importFile">Upload File</Label>
              <Input
                type="file"
                name="importFile"
                id="importFile"
                accept=".csv, .xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
                onChange={handleImportFileUpload}
              />
              {importedFileDetails && (
                <div className="mt-2">
                  <small>
                    File: {importedFileDetails.fileName}| Uploaded:{" "}
                    {importedFileDetails.uploadTime}
                  </small>
                </div>
              )}
            </FormGroup>
            <div className="text-center">
              <Button 
                style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} 
                type="submit"
                disabled={isImporting}
              >
                {isImporting ? (
                  <>
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Importing...
                  </>
                ) : (
                  'Import'
                )}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={showDeleteConfirmation}
        toggle={() => setShowDeleteConfirmation(false)}
      >
        <ModalHeader>Confirm Deletion</ModalHeader>
        <ModalBody>Are you sure you want to delete ?</ModalBody>
        <div className="modal-footer">
          <Button
            color="danger"
            onClick={() => handleDeleteConfirmation(true, deleteProjectName)}
          >
            Yes
          </Button>
          <Button
            color="secondary"
            onClick={() => setShowDeleteConfirmation(false)}
          >
            No
          </Button>
        </div>
      </Modal>

      {modalEmployee && modalEmployee && !isMultipleMaterials && (
        <Modal isOpen={modalOpen} toggle={toggleModalView}>
          <ModalHeader toggle={toggleModalView}>Material View</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="">
                  <label
                    className="border p-2 rounded font-weight-bold"
                    style={{ width: "155px" }}
                  >
                    Material Name
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.mat_name}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Budget
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.mat_money}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Quantity
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.mat_quantity}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Priority
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.Priority}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Date
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.Date_Time}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    General Manager
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.mat_status}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Store Manager
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.store_status || "N/A"}
                  </label>
                </div>
                <div>
                  <label
                    className="border p-2 rounded font-weight-bold "
                    style={{ width: "155px" }}
                  >
                    Action
                  </label>
                  <label className=" p-2 rounded font-weight-bold m-1 ">
                    :
                  </label>
                  <label className="border p-2 rounded ">
                    {modalEmployee.store_report || "N/A"}
                  </label>
                </div>
                {imagesArray.length > 0 && (
                  <div>
                    <label
                      className="border p-2 rounded font-weight-bold "
                      style={{ width: "155px" }}
                    >
                      Uploaded Images
                    </label>
                    <label className=" p-2 rounded font-weight-bold m-1 ">
                      :
                    </label>
                    <Carousel
                      activeIndex={activeIndex1}
                      next={next1}
                      previous={previous1}
                    >
                      <CarouselIndicators
                        items={imagesArray}
                        activeIndex={activeIndex1}
                        onClickHandler={goToIndex1}
                      />

                      {slides1}

                      <CarouselControl
                        direction="prev"
                        directionText="Previous"
                        onClickHandler={previous1}
                      />
                      <CarouselControl
                        direction="next"
                        directionText="Next"
                        onClickHandler={next1}
                      />
                    </Carousel>
                  </div>
                )}
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}

      {/* Multiple Materials Modal */}
      {multipleMaterialsData && isMultipleMaterials && (
        <Modal isOpen={modalOpen} toggle={toggleModalView} size="xl">
          <ModalHeader toggle={toggleModalView}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <span>Multiple Materials View ({multipleMaterialsData.materials.length} materials)</span>
              <Button
                color="success"
                size="sm"
                onClick={handleDownloadMultipleMaterials}
                style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
              >
                <i className="fas fa-download mr-1"></i>
                Download Excel
              </Button>
            </div>
          </ModalHeader>
          <ModalBody>
            {/* Metadata Section */}
            <div className="row mb-4">
              <div className="col-md-12">
                <h6 className="text-muted mb-3">Request Information</h6>
                <div className="row">
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">Priority</small>
                      <strong>{multipleMaterialsData.metadata.Priority || "N/A"}</strong>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">Date</small>
                      <strong>{multipleMaterialsData.metadata.Date_Time || "N/A"}</strong>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">General Manager</small>
                      <strong>{multipleMaterialsData.metadata.mat_status || "N/A"}</strong>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="border p-2 rounded">
                      <small className="text-muted d-block">Store Manager</small>
                      <strong>{multipleMaterialsData.metadata.store_status || "N/A"}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Materials Table */}
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="text-muted mb-0">Materials List</h6>
                  {multipleMaterialsData.materials.length > 5 && (
                    <div className="d-flex align-items-center">
                      <span className="mr-2 text-muted small">Show:</span>
                      <Dropdown
                        isOpen={modalEntriesDropdownOpen}
                        toggle={() => setModalEntriesDropdownOpen(!modalEntriesDropdownOpen)}
                        size="sm"
                      >
                        <DropdownToggle caret size="sm" className="px-3">
                          {modalEntriesPerPage === multipleMaterialsData.materials.length ? "All" : modalEntriesPerPage}
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={() => handleModalEntriesChange(5)}>5</DropdownItem>
                          <DropdownItem onClick={() => handleModalEntriesChange(10)}>10</DropdownItem>
                          <DropdownItem onClick={() => handleModalEntriesChange(15)}>15</DropdownItem>
                          <DropdownItem onClick={() => handleModalEntriesChange("All")}>All</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  )}
                </div>
                <div className="table-responsive" style={{maxHeight: '400px', overflowY: 'auto'}}>
                  <Table striped bordered hover size="sm">
                    <thead className="thead-light" style={{position: 'sticky', top: 0, zIndex: 1}}>
                      <tr>
                        <th style={{width: '5%'}}>Sr. No</th>
                        <th style={{width: '35%'}}>Material Name</th>
                        <th style={{width: '15%'}}>Quantity</th>
                        <th style={{width: '15%'}}>Budget</th>
                        <th style={{width: '10%'}}>Unit Price</th>
                        <th style={{width: '20%'}}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getModalPaginatedMaterials().map((material, index) => {
                        const quantity = parseFloat(material.mat_quantity) || 0;
                        const price = parseFloat(material.mat_money) || 0;
                        const total = quantity * price;
                        
                        return (
                          <tr key={index}>
                            <td>{getModalSerialNumber(index)}</td>
                            <td>
                              <div style={{wordBreak: 'break-word'}}>
                                {material.mat_name || "N/A"}
                              </div>
                            </td>
                            <td>{material.mat_quantity || "N/A"}</td>
                            <td>₹{material.mat_money || "N/A"}</td>
                            <td>₹{price.toFixed(2)}</td>
                            <td>₹{total.toFixed(2)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr className="font-weight-bold" style={{backgroundColor: '#f8f9fa'}}>
                        <td colSpan="5" className="text-right">Total Budget:</td>
                        <td>
                          ₹{multipleMaterialsData.materials.reduce((sum, material) => {
                            const quantity = parseFloat(material.mat_quantity) || 0;
                            const price = parseFloat(material.mat_money) || 0;
                            return sum + (quantity * price);
                          }, 0).toFixed(2)}
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
                
                {/* Pagination Controls */}
                {multipleMaterialsData.materials.length > 5 && getModalTotalPages() > 1 && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text-muted small">
                      Showing {((modalCurrentPage - 1) * modalEntriesPerPage) + 1} to {Math.min(modalCurrentPage * modalEntriesPerPage, multipleMaterialsData.materials.length)} of {multipleMaterialsData.materials.length} materials
                    </div>
                    <nav>
                      <ul className="pagination pagination-sm mb-0">
                        <li className={`page-item ${modalCurrentPage === 1 ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => handleModalPageChange(modalCurrentPage - 1)}
                            disabled={modalCurrentPage === 1}
                          >
                            Previous
                          </button>
                        </li>
                        {Array.from({ length: getModalTotalPages() }, (_, i) => i + 1).map((pageNumber) => (
                          <li key={pageNumber} className={`page-item ${pageNumber === modalCurrentPage ? 'active' : ''}`}>
                            <button
                              className="page-link"
                              onClick={() => handleModalPageChange(pageNumber)}
                              style={{
                                backgroundColor: pageNumber === modalCurrentPage ? '#d86f89' : 'transparent',
                                borderColor: pageNumber === modalCurrentPage ? '#d86f89' : '#dee2e6',
                                color: pageNumber === modalCurrentPage ? 'white' : '#007bff'
                              }}
                            >
                              {pageNumber}
                            </button>
                          </li>
                        ))}
                        <li className={`page-item ${modalCurrentPage === getModalTotalPages() ? 'disabled' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => handleModalPageChange(modalCurrentPage + 1)}
                            disabled={modalCurrentPage === getModalTotalPages()}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>

            {/* Images Section */}
            {multipleMaterialsData.metadata.files && (
              <div className="row mt-4">
                <div className="col-md-12">
                  <h6 className="text-muted mb-3">Uploaded Images</h6>
                  <Carousel
                    activeIndex={activeIndex1}
                    next={next1}
                    previous={previous1}
                  >
                    <CarouselIndicators
                      items={imagesArray}
                      activeIndex={activeIndex1}
                      onClickHandler={goToIndex1}
                    />
                    {slides1}
                    <CarouselControl
                      direction="prev"
                      directionText="Previous"
                      onClickHandler={previous1}
                    />
                    <CarouselControl
                      direction="next"
                      directionText="Next"
                      onClickHandler={next1}
                    />
                  </Carousel>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
      )}

      {/* Success Alert Modal for Material Request */}
      {showSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
            maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
          }}>
            <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
            <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
            <Button
              style={{
                backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                padding: '10px 25px', borderRadius: '25px'
              }}
              onClick={() => { setShowSuccessAlert(false); window.location.reload(); }}
            >OK</Button>
          </div>
        </div>
      )}

      {/* Date Range Filter Modal */}
      <Modal isOpen={dateRangeModalOpen} toggle={toggleDateRangeModal}>
        <ModalHeader toggle={toggleDateRangeModal}>
          <i className="fas fa-calendar-alt mr-2"></i>
          Filter by Date Range
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="startDate">Start Date</Label>
                  <Input
                    type="date"
                    id="startDate"
                    name="startDate"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="Select start date"
                  />
                  <small className="text-muted">
                    Leave empty to show from beginning
                  </small>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="endDate">End Date</Label>
                  <Input
                    type="date"
                    id="endDate"
                    name="endDate"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="Select end date"
                  />
                  <small className="text-muted">
                    Leave empty to show until current date
                  </small>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <div className="d-flex justify-content-between">
                  <Button
                    color="secondary"
                    onClick={clearFilters}
                    size="sm"
                  >
                    Clear Dates
                  </Button>
                  <div>
                    <Button
                      color="secondary"
                      onClick={toggleDateRangeModal}
                      className="mr-2"
                      size="sm"
                    >
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      onClick={applyDateRange}
                      size="sm"
                      style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                    >
                      Apply Filter
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Materials2;
